import {
  types,
  IGetDataStreamAllowedDomainsSuccessAction,
  IGetDataStreamAllowedDomainsFailureAction,
  IGetDataStreamAllowedDomainsAction,
  IGetDataStreamAllowedDomainsCancelAction,
} from '../types/config'

export const getDataStreamAllowedDomainsAction = (): IGetDataStreamAllowedDomainsAction => ({
  type: types.GET_DATASREAM_ALLOWED_DOMAINS__START,
})

export const getDataStreamAllowedDomainsSuccessAction = (
  domains: string[]
): IGetDataStreamAllowedDomainsSuccessAction => ({
  type: types.GET_DATASREAM_ALLOWED_DOMAINS__SUCCESS,
  domains,
})

export const getDataStreamAllowedDomainsFailureAction = (
  message: string
): IGetDataStreamAllowedDomainsFailureAction => ({
  type: types.GET_DATASREAM_ALLOWED_DOMAINS__FAILURE,
  message,
})

export const getDataStreamAllowedDomainsCancelAction = (): IGetDataStreamAllowedDomainsCancelAction => ({
  type: types.GET_DATASREAM_ALLOWED_DOMAINS__CANCEL,
})
